import type { RouterScrollBehavior } from "vue-router";

/**
 * URL-backed filters and sorts (`FilterSelect`, `FilterDateRange`, `useUrlSort`, `useQuerySubview`)
 * mirror their state with `router.replace({ query })`. Those navigations carry no `savedPosition`,
 * so the default top reset would throw the user back to the top of the page every time a filter
 * changes. Any navigation that keeps the same path is one of those, so leave scroll alone.
 */
export const scrollBehavior: RouterScrollBehavior = (to, from, savedPosition) => {
  if (savedPosition) {
    return savedPosition;
  }
  if (to.path === from.path) {
    return false;
  }
  return { left: 0, top: 0 };
};
